import { Auth0Provider, type AppState } from '@auth0/auth0-react';
import type { ReactNode } from 'react';
import { useNavigate } from 'react-router-dom';
import { Auth0ConfigurationContext } from './auth0_configuration';

interface AppAuth0ProviderProps {
  children: ReactNode;
  domain: string;
  clientId: string;
  audience?: string;
}

export function AppAuth0Provider({
  children,
  domain,
  clientId,
  audience,
}: AppAuth0ProviderProps) {
  const navigate = useNavigate();
  const isConfigured = domain.length > 0 && clientId.length > 0 && Boolean(audience);

  if (!isConfigured) {
    return (
      <Auth0ConfigurationContext.Provider value={false}>
        {children}
      </Auth0ConfigurationContext.Provider>
    );
  }

  const handleRedirect = (appState?: AppState) => {
    void navigate(appState?.returnTo ?? window.location.pathname, { replace: true });
  };

  return (
    <Auth0ConfigurationContext.Provider value>
      <Auth0Provider
        domain={domain}
        clientId={clientId}
        authorizationParams={{
          redirect_uri: window.location.origin,
          screen_hint: 'login',
          ...(audience ? { audience } : {}),
        }}
        onRedirectCallback={handleRedirect}
      >
        {children}
      </Auth0Provider>
    </Auth0ConfigurationContext.Provider>
  );
}
